var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftBotFramework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 39.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.99,39.8C9.39,40.39,0,30.84,0,20.02,0,8.91,9.33-.15,20.21,0c10.87,.15,19.78,9.05,19.79,20.03,.02,10.8-9.23,20.3-20.01,19.77Zm-.09-2.48c8.88,.32,17.53-7.03,17.51-17.39-.03-9.7-7.75-17.3-17.27-17.37C10.46,2.48,2.55,10.34,2.56,19.96c0,9.93,8.31,17.58,17.35,17.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.71,9.16c2.07,0,4.13-.01,6.2,0,1.36,.01,1.72,.32,1.82,1.68,.31,4.27,.06,8.54,.14,12.81,.02,1.05-.69,.99-1.41,1.01-.75,.02-1.27-.13-1.26-1.06,.02-3.51,0-7.03,0-10.54,0-1.35-.04-1.39-1.39-1.39-3.38,0-6.75,0-10.13,0-.42,0-.98,.17-1.19-.36-.23-.58-.23-1.23,0-1.82,.17-.42,.65-.32,1.01-.32,2.07,0,4.13,0,6.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,30.71c-2.07,0-4.13,0-6.2,0-1.26,0-1.72-.41-1.73-1.65-.02-4.24,0-8.47-.02-12.71,0-.98,.59-.99,1.29-1,.76-.01,1.25,.12,1.24,1.06-.03,3.48,.02,6.96-.03,10.44-.01,1.02,.28,1.39,1.35,1.38,3.44-.06,6.89-.03,10.33-.02,1.19,0,1.77,1,1.25,2.1-.23,.49-.68,.4-1.08,.4-2.14,.01-4.27,0-6.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,19.86c.1-1.04,1.04-1.86,2.05-1.76,.97,.09,1.72,1.02,1.64,2.03-.08,1.1-.92,1.78-2.06,1.67-.93-.1-1.72-1.03-1.63-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.91,20.01c-.03,1.09-.77,1.81-1.84,1.79-1.02-.02-1.85-.84-1.86-1.83,0-.98,.95-1.9,1.95-1.87,1.01,.03,1.77,.86,1.74,1.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftBotFramework);
export default __webpack_public_path__ + "static/media/Microsoft Bot Framework.1f6b994e22d95aa046b9fcbf004252b1.svg";
export { ForwardRef as ReactComponent };